var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c("h5", [_vm._v("Detalle de los lotes a facturar")]),
      _c("b-table", {
        staticClass: "bg-white",
        attrs: {
          small: "",
          fields: _vm.columns,
          items: _vm.mappedReceiptDataTable,
          responsive: "sm"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }